import { css } from 'styled-components';

/** Column width rules for the 5-column notices table (header/body stay aligned). */
export const historicalNoticesTableColumnStyles = css`
    th:nth-child(1),
    td:nth-child(1) {
        min-width: 10rem;
        max-width: 16rem;
    }

    th:nth-child(2),
    td:nth-child(2) {
        min-width: 4rem;
        max-width: 5rem;
    }

    th:nth-child(3),
    td:nth-child(3) {
        min-width: 4rem;
        max-width: 5rem;
    }

    th:nth-child(4),
    td:nth-child(4) {
        min-width: 8rem;
        max-width: 12rem;
    }

    th:nth-child(5),
    td:nth-child(5) {
        min-width: 7rem;
        max-width: 11rem;
    }
`;
